import React, { useMemo } from 'react';
import DefaultEmail from './defaultEmail';
import DHLBody from './dhlEmail';
import MDLZNewsletterBody from './mdlzNewsletter';
import { observer } from 'mobx-react';

function EmailTextFactory({ ui, ...rest }) {
    const Component = useMemo(() => {
        switch (ui.variant) {
            case 'dhl':
                return DHLBody;
            case 'mdlzNewsletter':
                return MDLZNewsletterBody;
            default:
                return DefaultEmail;
        }
    }, [ui]);

    return <Component ui={ui} {...rest} />;
}

export default observer(EmailTextFactory);
